import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { drawReq } from '../useDrawPreview/useDrawPreview';
import { spiceroad } from '..';

export interface UseDrawCreateProps {
  drawResult: any;
  isErrorDraw: Error | null;
  triggerDraw: any;
  mutation: UseMutationResult<any, Error, drawReq>;
}

export function useDrawCreate(locId: any): UseDrawCreateProps {
  const mutation = useMutation({
    mutationFn: (arg: drawReq) =>
      spiceroad
        .post(`/v1/locs/${locId}/draw/create`, arg)
        .then((res) => res.data),
    mutationKey: ['createDraw', locId],
  });

  return {
    drawResult: mutation.data,
    isErrorDraw: mutation.error,
    triggerDraw: mutation.mutateAsync,
    mutation,
  };
}

export default useDrawCreate;
